import { render } from "./AppleFooter.vue?vue&type=template&id=7aad9563&scoped=true"
import script from "./AppleFooter.vue?vue&type=script&lang=js"
export * from "./AppleFooter.vue?vue&type=script&lang=js"

import "./AppleFooter.vue?vue&type=style&index=0&id=7aad9563&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aad9563"]])

export default __exports__